"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_autolink_1 = __importDefault(require("react-native-autolink"));
const utilities_1 = require("../../../helper/utilities");
const theme_1 = require("../../../theme");
const helpers_1 = require("../../helpers");
const ExternalLink_1 = require("./ExternalLink");
const LinkPreview_1 = require("./LinkPreview");
const Message = ({ linkPreviewAPIUrl, message, renderImageGallery, openUrl, }) => {
    const [linkPreview, setLinkPreview] = react_1.useState();
    const theme = theme_1.useSharedTheme();
    const imageUrls = message.attachments
        .map((a) => { var _a; return (_a = a.imageUrls) === null || _a === void 0 ? void 0 : _a.original; })
        .filter(utilities_1.isNotNullOrUndefined);
    const renderLink = react_1.useCallback((text) => (react_1.default.createElement(ExternalLink_1.ExternalLink, { openUrl: openUrl, url: text },
        react_1.default.createElement(react_native_1.Text, { style: [styles.messageText, { color: theme.colors.textPrimary }] }, text))), [openUrl, theme]);
    react_1.useEffect(() => {
        if (message.linkPreviewUrl) {
            helpers_1.fetchLinkPreview(linkPreviewAPIUrl, message.linkPreviewUrl)
                .then((fetchedLinkPreview) => {
                setLinkPreview(fetchedLinkPreview);
            })
                .catch(() => undefined);
        }
    }, [linkPreviewAPIUrl, message.linkPreviewUrl]);
    let images = null;
    if (imageUrls.length > 0 && !message.body) {
        images = (react_1.default.createElement(react_native_1.View, { style: styles.imageGalleryWrapper }, renderImageGallery(imageUrls)));
    }
    else if (imageUrls.length > 0) {
        images = renderImageGallery(imageUrls);
    }
    return (react_1.default.createElement(react_native_1.View, { style: [
            styles.messageRow,
            message.isLastOfAuthorGroup ? styles.extraRowSpace : undefined,
            message.isOwn ? styles.isOwnRow : undefined,
        ] },
        react_1.default.createElement(react_native_1.View, { style: [
                styles.messageContainer,
                message.isOwn
                    ? {
                        backgroundColor: theme.colors.mailboxOwnMessageBackground,
                        borderTopRightRadius: 0,
                    }
                    : {
                        backgroundColor: theme.colors.mailboxOtherMessageBackground,
                        borderTopLeftRadius: 0,
                    },
            ] },
            message.linkPreviewUrl ? (react_1.default.createElement(react_native_1.View, { style: [
                    styles.linkPreviewButton,
                    { backgroundColor: theme.colors.surface },
                ] },
                react_1.default.createElement(ExternalLink_1.ExternalLink, { url: message.linkPreviewUrl },
                    react_1.default.createElement(LinkPreview_1.LinkPreview, { linkPreview: linkPreview })))) : null,
            images,
            message.body ? (react_1.default.createElement(react_native_1.View, { style: styles.textContainer },
                react_1.default.createElement(react_native_1.Text, null,
                    react_1.default.createElement(react_native_autolink_1.default, { text: message.body, email: false, url: true, stripPrefix: false, stripTrailingSlash: false, linkStyle: { color: theme.colors.textPrimary }, showAlert: false, onPress: openUrl, truncateLocation: 'smart', renderText: (text) => (react_1.default.createElement(react_native_1.Text, { style: styles.messageText }, text)), renderLink: renderLink })))) : null)));
};
exports.Message = Message;
const styles = react_native_1.StyleSheet.create({
    extraRowSpace: {
        marginBottom: 25,
    },
    imageGalleryWrapper: {
        flexDirection: 'row',
    },
    isOwnRow: {
        alignItems: 'flex-end',
    },
    linkPreviewButton: {
        width: '100%',
    },
    messageContainer: {
        alignItems: 'flex-start',
        borderRadius: 25,
        maxWidth: '80%',
        overflow: 'hidden',
        paddingBottom: 16,
        paddingLeft: 18,
        paddingRight: 24,
        paddingTop: 15,
    },
    messageRow: {
        alignItems: 'flex-start',
        margin: 2,
    },
    messageText: {
        fontFamily: theme_1.fontFamily,
        fontSize: 15,
        fontWeight: '300',
        lineHeight: 25,
    },
    textContainer: {
        width: '100%',
    },
});
